import React, { useEffect, useState, useMemo } from "react";
import {
  Accordion,
  Badge,
  Button,
  Col,
  Container,
  FloatingLabel,
  Form,
  Modal,
  Row,
  Stack,
} from "react-bootstrap";
import {
  getExtraWorkCategories,
  putExtraWorkInCategory,
} from "../../../apiMethod/extraWorkCategories";
import {
  deleteExtraWork,
  getExtraWorks,
  getSivilCoins,
  putCoeffExtraWork,
  putComplexityExtraWork,
  putConsideredInSivilSum,
  putNameExtraWork,
  putUserCheckExtraWork,
} from "../../../apiMethod/extraWorks";
import { AddExtraWork } from "./AddExtraWork";
import styles from "./ExtraWorksView.module.css";
import AddExtraWorkCategory from "./AddExtraWorkCategory";
import EditExtraWorkCategory from "./EditExtraWorkCategory";
import { FaRegEdit } from "react-icons/fa";

function ExtraWorksView({ jwt }) {
  const [extraWorks, setExtraWorks] = useState([]);
  const [extraWorkCategories, setExtraWorkCategories] = useState([]);
  const [isCreatingCategory, setIsCreatingCategory] = useState(false);
  const [isEditingCategory, setIsEditingCategory] = useState(-1);
  const [sivilCoins, setSivilCoins] = useState({ coins: 0, coinsNoMore: 0 });
  const [extraWorkLevel, setExtraWorkLevel] = useState([
    { id: 0, name: "Не выбрана" },
    { id: 1, name: "Простая" },
    { id: 2, name: "Средняя" },
    { id: 3, name: "Сложная" },
  ]);

  const [searchQuery, setSearchQuery] = useState("");

  const [currentDate, setCurrentDate] = useState(
    new Date().toLocaleDateString().split(".").reverse().join("-")
  );

  const filteredExtraWorks = useMemo(() => {
    if (!searchQuery) return extraWorks;

    return extraWorks.filter(work =>
      work.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [extraWorks, searchQuery]);

  Array.prototype.sortedExtraWork = function (tag) {
    return this.sort((a, b) => a[tag] - b[tag]);
  };
  useEffect(() => {
    async function DidMount() {
      const extraWorksData = await getExtraWorks(jwt);
      const sortedExtraWorks = await extraWorksData.sortedExtraWork(
        "extraWorkCategoryId"
      );
      setExtraWorks(sortedExtraWorks);
      setExtraWorkCategories(await getExtraWorkCategories(jwt));
    }

    DidMount();
  }, []);

  const updateExtraWork = (id, updatedFields) => {
    setExtraWorks(prev => prev.map(work =>
      work.id === id ? { ...work, ...updatedFields } : work
    ));
  };

  useEffect(() => {
    if (!currentDate) return;

    async function DidMount() {
      const responseSivilCoins = await getSivilCoins(currentDate, jwt);
      setSivilCoins(responseSivilCoins);
    }

    DidMount();
  }, [currentDate]);

  const updateExtraWorksList = (extraWorkData) => {
    setExtraWorks((prev) =>
      Array.isArray(prev) ? [...prev, extraWorkData] : [extraWorkData]
    );
  };

  const EditCategoryView = ({ show, handleClose, handleSave, oldValue }) => {
    const [value, setValue] = useState(oldValue);

    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Новое значение</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Категория</Form.Label>
              <FloatingLabel label="Выберите категорию">
                <Form.Select
                  aria-label="Выберите категорию"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                >
                  {extraWorkCategories.map((o) => (
                    <option key={o.id} value={o.id}>
                      {o.name}
                    </option>
                  ))}
                </Form.Select>
              </FloatingLabel>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Закрыть
          </Button>
          <Button variant="primary" onClick={() => handleSave(value)}>
            Сохранить
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const EditComplexityView = ({ show, handleClose, handleSave, oldValue }) => {
    const [value, setValue] = useState(oldValue);

    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Новое значение</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Сложность</Form.Label>
              <FloatingLabel label="Выберите сложность">
                <Form.Select
                  aria-label="Выберите сложность"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                >
                  {extraWorkLevel.map((o, i) => (
                    <option key={i} value={o.id}>
                      {o.name}
                    </option>
                  ))}
                </Form.Select>
              </FloatingLabel>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Закрыть
          </Button>
          <Button variant="primary" onClick={() => handleSave(value)}>
            Сохранить
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const EditNameView = ({ show, handleClose, handleSave, oldValue }) => {
    const [value, setValue] = useState(oldValue);

    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Новое название</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Название</Form.Label>
              <Form.Control
                type="text"
                placeholder={oldValue}
                autoFocus
                onChange={(e) => setValue(e.target.value)}
                value={value}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Закрыть
          </Button>
          <Button variant="primary" onClick={() => handleSave(value)}>
            Сохранить
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const EditCoeffView = ({ show, handleClose, handleSave, oldValue }) => {
    const [value, setValue] = useState(oldValue);

    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Новое значение</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Коэффициент</Form.Label>
              <Form.Control
                type="number"
                placeholder={oldValue}
                autoFocus
                onChange={(e) => setValue(e.target.value)}
                value={value}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Закрыть
          </Button>
          <Button variant="primary" onClick={() => handleSave(value)}>
            Сохранить
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const EditStateView = ({ show, handleClose, handleSave, newState }) => {
    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Подтвердите действие</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Вы уверены что хотите <strong>{newState}</strong> работу?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Закрыть
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Сохранить
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const EditDeleteView = ({ show, handleClose, handleSave }) => {
    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Подтвердите действие</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Вы уверены что хотите <strong>Удалить</strong> работу?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Закрыть
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Сохранить
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const ExtraWorkView = ({ extraWork, onUpdate }) => {
    const [id] = useState(extraWork.id);
    const [extraWorkCategoryId, setExtraWorkCategoryId] = useState(
      extraWork.extraWorkCategoryId
    );
    const [name, setName] = useState(extraWork.name);
    const [coefficient, setCoefficient] = useState(extraWork.coefficient);
    const [isUserCheck, setIsUserCheck] = useState(extraWork.isUserCheck);
    const [complexity, setComplexity] = useState(extraWork.complexity);

    const handleCheckboxChange = async (e) => {
      const newValue = e.target.checked;
      onUpdate(extraWork.id, { isConsideredInSivilSum: newValue });

      try {
        await putConsideredInSivilSum(extraWork.id, newValue, jwt);
        const responseSivilCoins = await getSivilCoins(currentDate, jwt);
        setSivilCoins(responseSivilCoins);

      } catch (error) {
        // Если ошибка - откатываем изменения
        onUpdate(extraWork.id, { isConsideredInSivilSum: !newValue });
        console.error("Ошибка при обновлении:", error);
      }
    };

    const [showEnable, setShowEnable] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showCoeff, setShowCoeff] = useState(false);
    const [showCategory, setShowCategory] = useState(false);
    const [showComplexity, setShowComplexity] = useState(false);
    const [showName, setShowName] = useState(false);

    return (
      <Accordion.Item eventKey={id} key={id}>
        <Accordion.Header>
          <Container fluid="md">
            <Row>
              <Col>{name}</Col>
              <Col>
                <Badge
                  pill
                  style={{ marginLeft: 4, marginRight: 4 }}
                  bg="primary"
                >
                  {coefficient}
                </Badge>
                {!isUserCheck ? (
                  <Badge pill bg="warning" text="dark">
                    {"Не доступно"}
                  </Badge>
                ) : (
                  <Badge pill bg="success">
                    Доступно
                  </Badge>
                )}
                <Badge
                  pill
                  style={{ marginLeft: 4, marginRight: 4 }}
                  text="dark"
                ></Badge>
                <Badge pill bg="info" text="dark">
                  {extraWorkLevel.filter((o) => o.id == complexity)[0].name}
                </Badge>
              </Col>
            </Row>
          </Container>
        </Accordion.Header>
        <Accordion.Body>
          <Container>
            <Row>
              <Col style={{ marginBottom: 6 }}>
                <div className="d-grid gap-2">
                  <Button variant="primary" onClick={() => setShowCoeff(true)}>
                    Коэффициент
                  </Button>
                </div>
              </Col>
              <Col style={{ marginBottom: 6 }}>
                <div className="d-grid gap-2">
                  <Button
                    variant="primary"
                    onClick={() => setShowCategory(true)}
                  >
                    Категория
                  </Button>
                </div>
              </Col>
              <Col>
                <div className="d-grid gap-2">
                  <Button
                    variant="primary"
                    onClick={() => setShowComplexity(true)}
                  >
                    Сложность
                  </Button>
                </div>
              </Col>
              <Col>
                <div className="d-grid gap-2">
                  <Button variant="primary" onClick={() => setShowName(true)}>
                    Название
                  </Button>
                </div>
              </Col>
            </Row>
            <Row style={{ marginTop: 12, marginBottom: 12 }}>
              <Col>
                <Form.Check
                  type="checkbox"
                  label="Учитывать в общей сумме баллов"
                  checked={extraWork.isConsideredInSivilSum}
                  onChange={handleCheckboxChange}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 6 }}>
              <Col>
                <div className="d-grid gap-2 ">
                  <Button
                    variant="outline-warning"
                    onClick={() => setShowEnable(true)}
                  >
                    Отключить
                  </Button>
                </div>
              </Col>
              <Col>
                <div className="d-grid gap-2 ">
                  <Button
                    variant="outline-danger"
                    onClick={() => setShowDelete(true)}
                  >
                    Удалить
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
          <EditNameView
            show={showName}
            handleClose={() => setShowName(false)}
            handleSave={(v) => {
              setShowName(false);
              putNameExtraWork(id, v, jwt);
              setName(v);
            }}
            oldValue={name}
          />
          <EditComplexityView
            show={showComplexity}
            handleClose={() => setShowComplexity(false)}
            handleSave={(v) => {
              setShowComplexity(false);
              putComplexityExtraWork(id, v, jwt);
              setComplexity(v);
            }}
            oldValue={complexity}
          />
          <EditCategoryView
            show={showCategory}
            handleClose={() => setShowCategory(false)}
            handleSave={(v) => {
              setShowCategory(false);
              putExtraWorkInCategory(v, id, jwt);
              setExtraWorkCategoryId(v);
            }}
            oldValue={extraWorkCategoryId}
          />
          <EditCoeffView
            show={showCoeff}
            handleClose={() => setShowCoeff(false)}
            handleSave={(v) => {
              setShowCoeff(false);
              putCoeffExtraWork(id, v, jwt);
              setCoefficient(v);
            }}
            oldValue={coefficient}
          />
          <EditStateView
            show={showEnable}
            handleClose={() => setShowEnable(false)}
            handleSave={() => {
              setShowEnable(false);
              putUserCheckExtraWork(id, !isUserCheck, jwt);
              setIsUserCheck(!isUserCheck);
            }}
            newState={isUserCheck ? "Выключить" : "Включить"}
          />
          <EditDeleteView
            show={showDelete}
            handleClose={() => setShowDelete(false)}
            handleSave={() => {
              setShowDelete(false);
              deleteExtraWork(jwt, id);
              setExtraWorks(extraWorks.filter((work) => work.id !== id));
            }}
          />
        </Accordion.Body>
      </Accordion.Item>
    );
  };

  const categoryId = 0;
  let currentCategoryId = categoryId;
  return (
    <div className={styles.psevdoBody}>
      <Accordion>
        <Stack gap={1} direction="vertical">
          <h3>Баллы: {sivilCoins.coins}</h3>
          <h3>Без прочих: {sivilCoins.coinsNoMore}</h3>
          <Form.Control
            type="date"
            value={currentDate}
            onChange={(e) => setCurrentDate(e.target.value)}
          />
          <Form.Control
            type="text"
            placeholder="Поиск по названию работы..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ marginBottom: '12px' }}
          />
        </Stack>
        <AddExtraWork
          props={[jwt, updateExtraWorksList, extraWorkCategories]}
        />
        <Button
          variant="primary"
          onClick={() => setIsCreatingCategory(true)}
          style={{ marginLeft: 4, marginBottom: 12 }}
        >
          Создать категорию
        </Button>
        {filteredExtraWorks && filteredExtraWorks.length > 0
          ? filteredExtraWorks.sortedExtraWork("extraWorkCategoryId").map((o) => {
            if (currentCategoryId !== o.extraWorkCategoryId) {
              currentCategoryId = o.extraWorkCategoryId;
              return (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <h1>
                      {
                        extraWorkCategories.find(
                          (item) => item.id === o.extraWorkCategoryId
                        )?.name
                      }
                    </h1>
                    {extraWorkCategories.find(
                      (item) => item.id === o.extraWorkCategoryId
                    ) != null ? (
                      <FaRegEdit
                        onClick={() =>
                          setIsEditingCategory(o.extraWorkCategoryId)
                        }
                        style={{
                          marginLeft: 10,
                          transform: "scale(1.5)",
                          cursor: "pointer",
                        }}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <Stack>
                    <ExtraWorkView key={o.id} extraWork={o} onUpdate={updateExtraWork} />
                  </Stack>
                </>
              );
            } else {
              return <ExtraWorkView key={o.id} extraWork={o} onUpdate={updateExtraWork} />;
            }
          })
          : searchQuery
            ? "Работы с таким названием не найдены"
            : "Куда-то делись все работы..."}
        {isCreatingCategory ? (
          <AddExtraWorkCategory
            show={isCreatingCategory}
            onHide={() => setIsCreatingCategory(false)}
            jwt={jwt}
            onCreated={(e) =>
              setExtraWorkCategories([...extraWorkCategories, e])
            }
          />
        ) : isEditingCategory != -1 ? (
          <EditExtraWorkCategory
            id={isEditingCategory}
            show={isEditingCategory}
            onHide={() => setIsEditingCategory(-1)}
            jwt={jwt}
            onUpdate={(u) => {
              const temp = [...extraWorkCategories];
              const index = temp.findIndex((f) => f.id == u.id);
              temp[index] = u;
              setExtraWorkCategories(temp);
            }}
            category={extraWorkCategories.find(
              (f) => f.id == isEditingCategory
            )}
          />
        ) : (
          ""
        )}
      </Accordion>
    </div>
  );
}

export default ExtraWorksView;
